import React, { useState } from "react";
import DefaultProfilePicture from "../defaultProfilePicture/DefaultProfilePicture";
import AttendeeProfile from "../../components/attendeeEvent/AttendeeProfile";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";

const MobileNavBar = ({ setSearch }) => {
  const [mobileSearch, setMobileSearch] = useState(false);
  const userDetails = useSelector((state) => state.userDetails);
  const { savedUserConfig } = userDetails;
  const [triggerProfile, setTriggerProfile] = useState(false);
  const [searchParams] = useSearchParams();

  const eventTab = searchParams.get("tab");

  //   useEffect(() => {
  //     dispatch(getUserDetails());
  //     console.log("here");
  //   }, [dispatch]);
  return (
    <div>
      {mobileSearch ? (
        <form
          className="flex items-center w-full md:hidden fixed top-0 z-30 justify-center h-[60px] bg-[#FAFAFA]"
          onSubmit={(event) => event.preventDefault()}
        >
          <div className="relative w-[90%] mt-3">
            <div className="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
              <img src="/svgs/Search.svg" className="h-[19px]" alt="search" />
            </div>
            <input
              type="text"
              id="simple-search"
              className="bg-[#FAFAFA] border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary focus:border-primary block w-full pl-10 pr-10 p-2  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary dark:focus:border-primary"
              placeholder={`Search ${eventTab ? eventTab : "upcoming"} events`}
              autoComplete="off"
              required={true}
              onChange={(e) => {
                setSearch(e.target.value);
              }}
              autoFocus
            />
            <div
              className="flex absolute inset-y-0 right-0 items-center pr-3  cursor-pointer z-40"
              onClick={() => {
                setMobileSearch(false);
                setSearch("");
              }}
            >
              <img
                src="/svgs/Cross.svg"
                className="h-[19px] cursor-pointer"
                alt="close"
              />
            </div>
          </div>
        </form>
      ) : (
        <div className="w-full h-[60px] fixed top-0 bg-[#FAFAFA] flex items-center justify-between px-[16px] z-30 md:hidden">
          <div className="flex items-center text-[22px] font-[500]">
            <img
              src="/svgs/logo.svg"
              alt="logo"
              className="w-[30px] mr-[5px]"
            />{" "}
            Warpbay
          </div>
          <div className="flex items-center">
            <img
              src="/svgs/Search.svg"
              className="w-[20px] h-[20px] object-cover cursor-pointer"
              onClick={() => setMobileSearch(true)}
              alt="search"
            />
            <img
              src="/svgs/Notifications.svg"
              className="w-[19px] h-[19px] object-cover cursor-pointer mx-[20px]"
              alt="notification"
            />
            {savedUserConfig?.profilePicture ? (
              <img
                src={savedUserConfig?.profilePicture}
                alt=""
                className="object-cover w-[24px] h-[24px] rounded-full cursor-pointer"
                onClick={() => setTriggerProfile(true)}
              />
            ) : (
              <div
                className="cursor-pointer"
                onClick={() => setTriggerProfile(true)}
              >
                <DefaultProfilePicture
                  firstName={savedUserConfig?.firstName}
                  lastName={savedUserConfig?.lastName}
                  style={{
                    width: "24px",
                    height: "24px",
                    borderRadius: "300px",
                    fontSize: "10px",
                  }}
                />
              </div>
            )}
          </div>
        </div>
      )}
      {triggerProfile && (
        <AttendeeProfile
          setTriggerProfile={setTriggerProfile}
          triggerProfile={triggerProfile}
          savedUserConfig={savedUserConfig}
        />
      )}
    </div>
  );
};

export default MobileNavBar;
